module.exports = __webpack_public_path__ + "static/media/ba.ed05e0ec.svg";